import { NgModule } from '@angular/core';

import { DeviceBehaviorPluginsModule } from '@shure/shared/angular/device-behavior/core';
import { DeviceImageBehaviorPluginService } from '@shure/shared/angular/device-behavior/plugins/device-image';
import { DeviceImageProvider } from '@shure/shared/angular/ui/components/device-image';

@NgModule({
	imports: [DeviceBehaviorPluginsModule.forRoot([])],
	providers: [
		{
			provide: DeviceImageProvider,
			useExisting: DeviceImageBehaviorPluginService
		}
	]
})
export class CloudDeviceBehaviorPluginsModule {}
